import type { ShopSitemapQuery, ShopSitemapQueryVariables } from '@/lib/goliath/goliath.types';

export default async (
  params: ShopSitemapQueryVariables = {},
  progress = true
): Promise<ShopSitemapQuery['offers']> =>
  globalThis.$goliathApi<ShopSitemapQueryVariables, ShopSitemapQuery, 'offers'>(
    'shop-sitemap',
    params,
    'offers',
    progress
  );
